import React, { Component } from 'react';
import { Chart, Geom, Axis, Tooltip, Legend } from 'bizcharts';
import { Card, Row, Col, Skeleton } from 'antd';
import DataSet from '@antv/data-set';
import PropTypes from 'prop-types';

class TotalBilledCollectedGraph extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    height: PropTypes.number,
    title: PropTypes.string,
    loading: PropTypes.bool
  };

  static defaultProps = {
    height: 400,
    title: 'Total Billed vs Collected Amount Comparison',
    loading: false
  };
  componentDidMount() {
    // Refer to this issue: https://github.com/alibaba/BizCharts/issues/279#issuecomment-400438180
    window.dispatchEvent(new Event('resize'));
    // Add a small delay to ensure both charts are rendered
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }
  formatPrice = value => {
    if (value === null || value === undefined || isNaN(value)) return 'RM 0.00';
    const formattedValue = parseFloat(value).toFixed(2);
    const numberWithComma = formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `RM${numberWithComma}`;
  };
  render() {
    const { data, height, title } = this.props;
    // console.log(data, 1);

    // Transform the API data to chart format for monthly
    const monthlyChartData = data.map(item => ({
      month: item.month,
      'Total Billed': item['Monthly Total Billed'] || 0,
      'Total Collected': item['Monthly Total Collected'] || 0
    }));

    // Transform the API data to chart format for yearly
    const yearlyChartData = data.map(item => ({
      month: item.month,
      'Total Billed': item['Yearly Total Billed'] || 0,
      'Total Collected': item['Yearly Total Collected'] || 0
    }));

    // Create datasets for both charts
    const monthlyDs = new DataSet();
    const monthlyDv = monthlyDs.createView().source(monthlyChartData);
    monthlyDv.transform({
      type: 'fold',
      fields: ['Total Billed', 'Total Collected'],
      key: 'type',
      value: 'amount'
    });

    const yearlyDs = new DataSet();
    const yearlyDv = yearlyDs.createView().source(yearlyChartData);
    yearlyDv.transform({
      type: 'fold',
      fields: ['Total Billed', 'Total Collected'],
      key: 'type',
      value: 'amount'
    });

    const chartHeight = height || 400;

    return (
      <div style={{ marginBottom: '16px' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Card
              title="Monthly Billing vs Collection"
              bordered={false}
              style={{
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                height: '100%'
              }}
              headStyle={{
                backgroundColor: '#fafafa',
                borderBottom: '1px solid #f0f0f0',
                fontWeight: 600
              }}
            >
              <Skeleton loading={this.props.loading} active paragraph={{ rows: 10 }}>
                <Chart height={chartHeight} data={monthlyDv} forceFit>
                  <Legend
                    textStyle={{
                      fontSize: '14'
                    }}
                    itemFormatter={val => {
                      if (val === 'Total Billed') return 'Billed';
                      if (val === 'Total Collected') return 'Collected';
                      return val;
                    }}
                  />
                  <Axis
                    name="month"
                    label={{
                      textStyle: {
                        fontSize: '12',
                        fill: '#666'
                      }
                    }}
                  />
                  <Axis
                    name="amount"
                    label={{
                      formatter: this.formatPrice,
                      textStyle: {
                        fontSize: '12',
                        fill: '#666'
                      }
                    }}
                  />
                  <Tooltip
                    formatter={(title, items) => {
                      return items.map(item => ({
                        ...item,
                        value: this.formatPrice(item.value)
                      }));
                    }}
                  />
                  <Geom
                    type="interval"
                    position="month*amount"
                    color={['type', ['#1890ff', '#E97451']]}
                    adjust={[
                      {
                        type: 'dodge',
                        marginRatio: 0.1
                      }
                    ]}
                    style={{
                      radius: [2, 2, 0, 0]
                    }}
                  />
                </Chart>
              </Skeleton>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title="Yearly Billing vs Collection"
              bordered={false}
              style={{
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                height: '100%'
              }}
              headStyle={{
                backgroundColor: '#fafafa',
                borderBottom: '1px solid #f0f0f0',
                fontWeight: 600
              }}
            >
              <Skeleton loading={this.props.loading} active paragraph={{ rows: 10 }}>
                <Chart height={chartHeight} data={yearlyDv} forceFit>
                  <Legend
                    textStyle={{
                      fontSize: '14'
                    }}
                    itemFormatter={val => {
                      if (val === 'Total Billed') return 'Billed';
                      if (val === 'Total Collected') return 'Collected';
                      return val;
                    }}
                  />
                  <Axis
                    name="month"
                    label={{
                      textStyle: {
                        fontSize: '12',
                        fill: '#666'
                      }
                    }}
                  />
                  <Axis
                    name="amount"
                    label={{
                      formatter: this.formatPrice,
                      textStyle: {
                        fontSize: '12',
                        fill: '#666'
                      }
                    }}
                  />
                  <Tooltip
                    formatter={(title, items) => {
                      return items.map(item => ({
                        ...item,
                        value: this.formatPrice(item.value)
                      }));
                    }}
                  />
                  <Geom
                    type="interval"
                    position="month*amount"
                    color={['type', ['#1890ff', '#E97451']]}
                    adjust={[
                      {
                        type: 'dodge',
                        marginRatio: 0.1
                      }
                    ]}
                    style={{
                      radius: [2, 2, 0, 0]
                    }}
                  />
                </Chart>
              </Skeleton>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default TotalBilledCollectedGraph;
